module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Dedicated to all my teachers —")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Those who gave me many years of guidance"), _c('br'), _vm._v("And those who offered transforming moments of inspiration")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In gratitude for the great blessings of the Dharma")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Lord Buddha Shakyamuni, Guru Rinpoche,"), _c('br'), _vm._v("Anagarika Sri Munindra, Sri S. N. Goenka,"), _c('br'), _vm._v("Mrs. Nani Bala Barua (Dipa Ma), Joshu Sasaki Roshi,"), _c('br'), _vm._v("His Holiness the Dalai Lama, the Venerable Mahasi Sayadaw,"), _c('br'), _vm._v("the Venerable Sayadaw U Pandita,"), _c('br'), _vm._v("His Holiness the Sixteenth Karmapa,"), _c('br'), _vm._v("Dilgo Khyentse Rinpoche,"), _c('br'), _vm._v("Tulku Urgyen Rinpoche, Nyoshul Khen Rinpoche,"), _c('br'), _vm._v("and Tsoknyi Rinpoche")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-573b8a7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062026361_epub_ded_r1.vue
// module id = 63
// module chunks = 0